import { post } from "../../../utils";
/**
 * FlowOperateReq
 */

export var apiTaskOperate = function apiTaskOperate(data) {
  return post({
    url: '/flow/core/operate',
    data: data,
    loading: true,
    errorTip: true
  });
};

// export const apiTaskForceAssign = (taskOrderId: string, user: IUserData) => {
//   return post<FlowOperateResult>({
//     url: '/flow/core/operate',
//     data: {
//       operateType: 'ASSIGN',
//       force: true,
//       taskOrderId,
//       formValue: JSON.stringify({
//         acceptReason: `强制转交 (${envVersion})`,
//         accepter: user.userName,
//         accepterCode: user.userCode,
//       }),
//     },
//     loading: true,
//     errorTip: true,
//   })
// }

/**
 * 处理结果
 *
 * FlowOperateResult
 */